export enum PageTab {
  Contacts = 'contacts',
  Coworkers = 'coworkers',
  Groups = 'groups',
  Pending = 'pending',
}
